import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import DragAndDropGame from "../../../components/games/DragAndDropGame";
import MemoryGame from "../../../components/games/MemoryGame";
import PuzzleGame from "../../../components/games/PuzzleGame";
import LoadingSpinner from "../../../components/LoadingSpinner";
import lessonServices from "../../../services/lessonServices";
import { getLanguage } from "../../../utils/getLanguage";

const StudentLessonGames = () => {
  const { id: lessonID } = useParams();
  const [gameDetails, setGameDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const lang = getLanguage();

  useEffect(() => {
    const fetchGame = async () => {
      setIsLoading(true);
      try {
        const data = await lessonServices.getLessonGames(lessonID);
        setGameDetails(data);
      } catch (err) {
        console.error("Failed to load game details:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchGame();
  }, [lessonID, lang]);

  if (isLoading) return <LoadingSpinner />;
  if (!gameDetails) return null;

  return (
    <>
      {gameDetails.type === 1 && <MemoryGame gameDetails={gameDetails} />}
      {gameDetails.type === 2 && <PuzzleGame gameDetails={gameDetails} />}
      {gameDetails.type === 3 && <DragAndDropGame gameDetails={gameDetails} />}
    </>
  );
};

export default StudentLessonGames;
